{
  "Approve": "Aprovar",
  "DeleteReminder": "Excluir lembrete",
  "DismissAlert": "Ignorar",
  "DismissReminder": "Ignorar lembrete",
  "Earlier": "ANTERIORMENTE",
  "EditReminder": "Editar lembrete",
  "High": "ALTA",
  "MarkAllAsRead": "Marcar tudo como lido",
  "Reject": "Rejeitar",
  "RemindMe15Min": "Lembrar em 15 minutos",
  "RemindMe5Min": "Lembrar em 5 minutos",
  "RemindMe60Min": "Lembrar em uma hora",
  "RemindMeTomorrow": "Lembre-me amanhã",
  "Snooze": "Lembre-me",
  "markAsRead": "Marcar como lido",
  "markAsUnread": "Marcar como não lido",
  "noNotifications": "Você receberá informações importantes sobre nossos produtos, sua colaboração com outros usuários e outras atualizações relevantes",
  "noNotificationsTitle": "As notificações aparecerão aqui"
}
